import React, { useState, useRef, useEffect } from 'react';
import Ratingstar from './Ratingstar';
import { IoIosArrowDown } from "react-icons/io";

export default function Gigreview({ 
  totalReviews = 0, 
  oneStar = 0, 
  twoStar = 0, 
  threeStar = 0, 
  fourStar = 0, 
  fiveStar = 0,
  averageRating = 0,
  onFilterChange
}) {
  const [isOpen, setIsOpen] = useState(false);
  const [filter, setFilter] = useState('All Reviews');
  const dropdownRef = useRef(null);

  const handleFilterChange = (option) => {
    setFilter(option);
    setIsOpen(false);
    if (onFilterChange) {
      onFilterChange(option);
    }
  };

  const ratings = [
    { label: '5 Stars', count: fiveStar, stars: 5 },
    { label: '4 Stars', count: fourStar, stars: 4 },
    { label: '3 Stars', count: threeStar, stars: 3 },
    { label: '2 Stars', count: twoStar, stars: 2 },
    { label: '1 Star', count: oneStar, stars: 1 },
  ];

  const calculateWidth = (count) => {
    if (totalReviews === 0) return '0%';
    return `${(count / totalReviews) * 100}%`;
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="md:mt-10 font-['Poppins']">
      <div className="text-[15px] md:text-xl font-medium md:font-semibold text-[#174568] mb-3 md:mb-6">Client Reviews</div>

      <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 mb-8">
        <div className="flex items-center gap-4">
          <div className="text-3xl md:text-4xl font-semibold md:font-bold text-[#174568]">{averageRating.toFixed(1)}</div>
          <div>
            <Ratingstar rating={averageRating} size={20} />
            <div className="text-sm text-gray-500 mt-1">{totalReviews} total Reviews</div>
          </div>
        </div>

        <div className="flex items-center gap-3">
          <div className="text-[12px] font-normal md:text-sm md:font-medium text-gray-600">Show Only</div>
          <div className="relative" ref={dropdownRef}>
            <button
              onClick={() => setIsOpen(!isOpen)}
              className="rounded-md border border-[#174568] bg-[#F9F9FF] text-[#174568] hover:bg-[#174568] hover:text-white transition-all flex items-center px-2 md:px-4 py-1 md:py-2 text-sm font-normal md:font-medium min-w-[160px] justify-between"
            >
              {filter}
              <IoIosArrowDown className={`ml-2 transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`} />
            </button>
            {isOpen && (
              <div className="absolute right-0 mt-2 w-48 bg-white border border-gray-200 rounded-lg shadow-xl z-[110] overflow-hidden animate-in fade-in zoom-in-95 duration-200">
                <div className="p-2 space-y-1">
                  {['All Reviews', 'Positive Reviews', 'Critical Reviews'].map((option) => (
                    <button
                      key={option}
                      onClick={() => handleFilterChange(option)}
                      className={`w-full text-left px-3 py-2 text-sm rounded transition-colors ${
                        filter === option ? 'bg-gray-100 text-[#174568] font-medium md:font-semibold' : 'hover:bg-gray-50 text-gray-600'
                      }`}
                    >
                      {option}
                    </button>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      <div className="max-w-[700px] space-y-4">
        {ratings.map((rating, index) => (
          <div key={index} className="flex items-center gap-4">
            <span className="w-16 text-sm text-gray-600 font-medium">{rating.label}</span>
            <div className="flex-grow h-3 bg-gray-100 rounded-full overflow-hidden shadow-inner">
              <div 
                className="h-full bg-[#174568] rounded-full transition-all duration-500"
                style={{ width: calculateWidth(rating.count) }}
              ></div>
            </div>
            <div className="w-32 flex justify-end">
              <Ratingstar rating={rating.stars} size={14} />
            </div>
            <span className="w-8 text-sm text-gray-400 text-right">{rating.count}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
